import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getPaymentMethods(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/payment-methods/get', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    getPaymentMethod(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/payment-methods/view/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addPaymentMethod(ctx, paymentMethodData) {
      console.log('add', paymentMethodData)
      return new Promise((resolve, reject) => {
        axios
          .post('/payment-methods/add', { data: paymentMethodData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
    editPaymentMethod(ctx, paymentMethodData) {
      console.log('Edit', paymentMethodData)
      return new Promise((resolve, reject) => {
        axios
          .post(`/payment-methods/edit/${paymentMethodData.id}`, { data: paymentMethodData })
          .then(response => {
            resolve(response)
          })

          .catch(error => reject(error.response))
      })
    },
  },
}
